<chd-dialog
  data-testid="delete_configuration_modal"
  [label]="titleString() ?? ''"
  [visible]="visible()"
  (closed)="onCloseModal()"
>
  <div class="content-container">
    @for (message of normalizedMessage(); track $index) {
      <chd-text>{{ message }}</chd-text>
    }
  </div>
  @for (button of buttons(); track button) {
    <chd-button
      chd-dialog-actions
      [attr.data-testid]="button.dataTestID"
      [disabled]="button.disabled?.() ?? false"
      [icon]="button.icon ?? ''"
      [label]="button.label ?? ''"
      [variant]="(button.shape === 'link' ? 'text' : button.shape) ?? 'primary'"
      (clicked)="button.action?.(); closeModal()"
    />
  }
</chd-dialog>
